import api from '../axios'


export default {
  login: (payload) => api.post('supplier/login', payload),
  // logout: () => api.get('/staff/logout'),
  getCurrentUser: () => api.get('/supplier/get-current'),
  getPermissions: () => api.get('/supplier/get-current-permissions'),
}
